import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'

const URL = `/landing/contact-form`

const contact = (data: {
  name: string
  email: string
  theme: string
  message: string
}): AxiosPromise => apiFetch(URL, { data, method: `POST` })

export default contact
